function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-27-14h54v36h-54z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#dc171d",
  d: "M-6-14H6v36H-6z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "c",
  fill: "#fff",
  transform: "scale(1.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  id: "a",
  transform: "rotate(18 3.157 -.5)",
  d: "M0 0v1h.5z"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  transform: "scale(-1 1)"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b",
  transform: "rotate(72)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b",
  transform: "rotate(-72)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b",
  transform: "rotate(144)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b",
  transform: "rotate(-144)"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "d"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c",
  transform: "translate(8 3.314)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c",
  transform: "translate(3.314 8)"
}));

var _ref6 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d",
  transform: "scale(-1 1)"
});

var SvgAn = function SvgAn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-27 -14 54 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("path", {
    fill: "#00007b",
    style: {
      fill: "#012a87",
      fillOpacity: 1
    },
    d: "M-27-2h54v12h-54z"
  }), _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/an.28a8afcf.svg";
export { ForwardRef as ReactComponent };